var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"text-caption ml-4"},[_vm._v("Gemiddelde over periode: "+_vm._s(_vm.average))]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('apexchart',{attrs:{"width":"100%","height":"350","type":"line","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }